import { watchTrends, watchIntro } from "@/mocks/editorial";
import SectionHeader from "./SectionHeader";

const heatStyles: Record<string, string> = {
  "爆点密集": "bg-primary-100 text-primary-700",
  "持续发酵": "bg-accent-100 text-accent-700",
  "破圈传播": "bg-secondary-100 text-secondary-700",
  "指数增长": "bg-foreground-800 text-background-50",
};

export default function WatchSection() {
  return (
    <section id="watch" className="scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeader
              kicker="正在关注"
              title="哪些类型最容易“瓜爆”？"
              desc={watchIntro}
            />
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
            {watchTrends.map((t, i) => (
              <article
                key={t.title}
                className="group relative flex flex-col gap-3 rounded-2xl border border-background-200 bg-background-100/70 p-5 transition-colors hover:bg-background-100"
              >
                <div className="flex items-center justify-between">
                  <span className="font-heading text-3xl font-semibold text-background-300 transition-colors group-hover:text-primary-200">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span
                    className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium ${heatStyles[t.heat] ?? "bg-secondary-100 text-secondary-700"}`}
                  >
                    {t.heat}
                  </span>
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">
                    {t.title}
                  </h3>
                  <p className="mt-1 text-xs font-medium uppercase tracking-wide text-accent-700">
                    {t.tag}
                  </p>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">
                  {t.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}